import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeConfigModule } from 'src/app/font-awesome-config.module';
import { MaterialModule } from 'src/app/material.module';
import { TreeGroupComponent } from './tree-group/tree-group.component';
import { TreeNestedNodeComponent } from './tree-nested-node/tree-nested-node.component';
import { TreeComponent } from './tree/tree.component';
import { TreeSearchComponent } from './tree-search/tree-search.component';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeConfigModule,
    MaterialModule,
    DirectivesModule
  ],
  declarations: [
    TreeComponent,
    TreeGroupComponent,
    TreeNestedNodeComponent,
    TreeSearchComponent
  ],
  exports: [
    TreeComponent,
    TreeGroupComponent,
    TreeNestedNodeComponent,
    TreeSearchComponent
  ]
})
export class TreeModule { }
